export { ImageTextBlockRenderer } from './ImageTextBlockRenderer'
export type { ImageTextBlockRendererProps } from './ImageTextBlockRenderer'
